export function getVersionFromModuleCount(moduleCount: number): number {
  return (moduleCount - 17) / 4;
}
